export { PagerComponent } from './pager.component';
export { PaginationComponent } from './pagination.component';
export { PaginationModule } from './pagination.module';
export { PaginationConfig } from './pagination.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/pagination/index.js
// module id = 621
// module chunks = 16